// Zentrale Design-Tokens für das EN:POWER Angebotssystem.
// Alle Pages/Sections/Cards beziehen Pixelwerte aus dieser Datei,
// damit Abstände & Farben konsistent bleiben (8px-Raster).

export const colors = {
  navy: '#122A5C',
  navyDeep: '#0E1E3C',
  orange: '#E07000',
  orangeSoft: 'rgba(224,112,0,0.15)',
  white: '#FFFFFF',
  bgSoft: '#F8FAFC',
  bgCard: '#FAFBFC',
  border: '#E2E8F0',
  muted: '#475569',
  slateLight: '#94A3B8',
  slateMid: '#64748B',
  slateDark: '#334155',
  amberBg: '#FFFBF5',
  amberBorder: '#FED7AA',
  amberText: '#92400E',
  green: '#16A34A',
};

// 8px-Raster-konforme Spacing-Tokens (A4-skaliert)
export const space = {
  xs: 4,    // tight pairs (dot + label)
  sm: 8,    // icon ↔ label
  md: 16,   // verwandte Elemente / Card-Gap im Grid
  lg: 24,   // Heading → Content / Section-Top-Padding
  xl: 32,   // zwischen Sektionen innerhalb einer A4-Seite
  xxl: 48,  // horizontales Section-Padding (A4-Rand)
};

// Typografie-Tokens
export const fonts = {
  display: 'Outfit, sans-serif',
  body: 'Manrope, sans-serif',
};

export const fontSize = {
  eyebrow: '9px',
  body: '10.5px',
  bodySm: '9.5px',
  bodyXs: '8.5px',
  bodyTiny: '8px',
  h2: '19px',
  h3: '12px',
  h3Sm: '11px',
  kpiNumber: '28px',
  pricingNumber: '26px',
  hero: '60px',
};
